module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00060.b68ff50.png";